import {EntryRowTypeHelpers} from 'common/query-builder/query-entry-section/row-types/types';
import {EntryPart, MetricEntry} from 'common/query-builder/query-entry-section/types';

import {NewMetricEntryRow} from './index';
import {getNewEntry} from './utils';

export const helpers: EntryRowTypeHelpers<MetricEntry> = {
  component: NewMetricEntryRow,
  getNewEntry: () => {
    return getNewEntry({
      isExpanded: true,
    });
  },
  isPlaceholder: ({entry}) => {
    const behaviors = entry.behavior.behaviors || [];
    return behaviors.length === 0 || !behaviors.every((behavior) => !!behavior.name);
  },
  getDefaultActiveEntryPart: () => {
    return EntryPart.Value;
  },
};
